import { REQUIRED_FIELD } from '@/utils/validationMessagesUtils'

export default {
  accountNameErrors () {
    const errors = []
    if (!this.$v.accountName.$dirty) return errors
    !this.$v.accountName.required && errors.push(REQUIRED_FIELD)
    return errors
  }
}